import { z } from 'zod';

import { EmailStringSchema } from '../../common';
import { makeEndpoint } from '../common';
import { PersonSchema } from '../user/person';

export enum WaitlistActivity {
  WAITLIST_JOINED = 'waitlist-joined',
  WAITLIST_INVITATION_OFFERED = 'waitlist-invitation-offered',
}

const BaseWaitlistEntryActivitySchema = z.object({
  topic: z.nativeEnum(WaitlistActivity),
  issuer: PersonSchema.extend({
    emailAddress: EmailStringSchema,
  }),
  createdAt: z.string().datetime(),
});

export const WaitlistJoinedActivitySchema = BaseWaitlistEntryActivitySchema;
export const WaitlistInvitationOfferedActivitySchema = BaseWaitlistEntryActivitySchema;

export const WaitlistEntryActivitySchema = z.union([WaitlistJoinedActivitySchema, WaitlistInvitationOfferedActivitySchema]);

const WaitlistEntriesActivitiesResponseSchema = z.array(WaitlistEntryActivitySchema);

export const GetWaitlistEntryActivitiesEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, waitlistId, waitlistEntryId }: { brandId: string; waitlistId: string; waitlistEntryId: string }) =>
    `v1/brands/${brandId}/waitlists/${waitlistId}/entries/${waitlistEntryId}/activities`,
  requestSchema: z.void(),
  responseSchema: WaitlistEntriesActivitiesResponseSchema,
});
